import { Component } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/index';
import { isMobile } from 'src/index/services.index';
import { HasDashboardSidebar } from '../shared/mixins/has-dashboard-sidebar.mixin';

@Component({
    selector: 'meta-global-calendar.',
    templateUrl: './global-calendar.component.html',
    styleUrls: ['./global-calendar.component.css'],
})
export class GlobalCalendarComponent extends HasDashboardSidebar {
    override activeItem$ = new BehaviorSubject<string>('calendar');

    config = { ...environment.calendarModule };

    hideFooter = this.config?.hideFooter ?? environment.hideFooter;
    hideMetaCredits = this.config?.hideMetaCredits ?? environment.hideMetaCredits;

    sideBarShown$ = new BehaviorSubject(!this.config.hideSidebar && !isMobile());
}
